/**
 * 
 * Textarea Box
 * 
 */

import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';

class TextareaBox extends React.Component {

    render() {
        const { name, label, value, placeholder, fieldStatus, onInputChange, defaultValue, disabled } = this.props;
        const display = fieldStatus && fieldStatus === "Display Only";
        return (<div className="p-col-12">
            {!display ? <label className="label">
                {label}
                {/* <span className="requiredColor">*</span> */}
            </label> : null}
            <div className={display ? "mt3": "mt1"}>
                {display ?
                    <div> Date: {value || defaultValue}</div> :
                    <InputTextarea
                        className="p-col-12"
                        value={value != null ? value : (defaultValue || '')}
                        name={name}
                        disabled={disabled}
                        onChange={onInputChange}
                        placeholder={placeholder} />}
            </div>
        </div>)
    }
}


export default TextareaBox;